export default __webpack_public_path__ + "static/media/line3.795242d7.svg";